export const IndividualTariffsMain = [
    {
        name: '',
        key: 'weight',
        typeId: null,
    },
    {
        name: 'Эконом',
        key: 'car',
        typeId: 1,
    },
    {
        name: 'Эконом',
        key: 'fly',
        typeId: 1,
    },
    {
        name: 'Экспресс',
        key: 'fly',
        typeId: 2,
    },
    {
        name: 'Эконом',
        key: 'fly',
        typeId: 1,
    },
    {
        name: 'Экспресс',
        key: 'fly',
        typeId: 2,
    },
]

export const IndividualTariffs = [
    {
        is_title: true,
        weight: 'Вес груза',
        titles: ['Зона 1', 'Зона 2', 'Зона 2', 'Зона 3', 'Зона 3'],
    },
    {
        weight: 'до 0.5 кг',
    },
    {
        weight: 'до 1 кг',
    },
    {
        weight: 'от 1 до 2 кг',
    },
    {
        weight: 'от 2 до 5 кг',
    },
    {
        weight: 'от 5 до 10 кг',
    },
    {
        weight: 'свыше 10 кг',
    },
]

export const StandardParamsColumns = [
    {
        name: 'Название',
        key: 'description',
        typeId: null,
    },
    {
        name: 'Количество (авто)',
        key: 'amount',
        typeId: 1,
    },
    {
        name: 'Количество (авиа)',
        key: 'amount',
        typeId: 2,
    },
]

export const StandardParamsRows = [
    {
        name: 'fuelPercent',
        description: 'Процент за топливо',
    },
    {
        name: 'insminPrice',
        description: 'Минимальная сумма для страхования',
    },
    {
        name: 'inscostPercent',
        description: 'Процент для выставления страховой суммы',
    },
    {
        name: 'unloadPrice',
        description: 'Выгрузка',
    },
    {
        name: 'packPrice',
        description: 'Упаковка',
    },
    {
        name: 'regionalCoefficient',
        description: 'Процент для региональной перевозки',
    },
    {
        name: 'orderPrice',
        description: 'Стоимость заказа',
    },
    {
        name: 'selfDeliveryPercent',
        description: 'Самовывоз',
    },
    {
        name: 'pickupPercent',
        description: 'Самопривоз',
    },
    {
        name: 'cubSize',
        description: 'Величина куба',
    },
    {
        name: 'overloadWeight',
        description: 'Вес учета минималки',
    },
    {
        name: 'distributionCenterDiscount',
        description: 'Скидка за доставку в ПВЗ',
    },
    {
        name: 'minInsCheckPrice',
        description: 'Сумма для проверки вычета страховки по проценту',
    },
]

export const AdditionalServicesColumns = [
    {
        name: 'Доп. услуга',
        key: 'name',
    },
    {
        name: 'Цена',
        key: 'price',
    },
    {
        name: 'Мин. значение',
        key: 'minValue',
    },
]

export const UniqueTariffsOne = [
    {
        name: 'Вес',
        key: 'weight',
    },
    {
        name: 'Цена',
        key: 'minimumPrice',
    },
    {
        name: 'Цена за кг',
        key: 'cost',
    },
    {
        name: '',
        key: 'action',
    },
]

export const UniqueTariffs = [
    {
        weight: 'до 0.5 кг',
    },
    {
        weight: 'до 1 кг',
    },
    {
        weight: 'до 2 кг',
    },
    {
        weight: 'до 5 кг',
    },
    {
        weight: 'до 10 кг',
    },
    {
        weight: 'свыше 10 кг',
    },
]
